const formatCurrency = (value: string) => {
  const number = parseFloat(value);
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }).format(number);
};

export default formatCurrency;